import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex flex-col',
    header:
      'hover:text-brand-accent mb-4.5 flex w-full cursor-pointer items-center justify-between font-medium',
    label: 'flex items-center gap-2',
    chevron: 'block rotate-0 transition-transform',
    search: 'mb-1',
    options: 'mt-3 mb-10 flex flex-col gap-6',
    collapse: ''
  },
  variants: {
    collapse: {
      false: {
        chevron: 'rotate-180',
        collapse: '!max-h-max'
      }
    }
  }
});
